import Vue, { CreateElement } from '@src/vue'
import { Component, Prop } from 'vue-property-decorator'

import './rating.sass'
import { Icon } from '@src/elements/icon/icon'

@Component
export class Rating extends Vue {

  @Prop({ required: true })
  max: number

  @Prop({ required: true })
  currentValue: number

  @Prop({ required: true })
  selectRating: (value: number) => void

  render (h: CreateElement) {
    let stars: any[] = []
    for (let i = 1; i <= this.max; i++) {
      if (i <= this.currentValue) {
        stars.push(<Icon name='util/star' class='filled' click={() => this.selectRating(i)} />)
      } else {
        stars.push(<Icon name='util/star' click={() => this.selectRating(i)} />)
      }
    }

    return <div class='rating'>
      {stars}
    </div>
  }
}
